'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { DropdownRootContext } from './context/dropdown-root.context';
import type { DropdownPortalPropsInterface } from './types/dropdown-portal.types';

/**
 * @since 10.0.0
 */
export const DropdownPortal = (props: DropdownPortalPropsInterface) => {
  const { dropdown } = useContext(DropdownRootContext);
  const { preserveTabOrder = true, ...rest } = props;

  if (!dropdown.isMounted) {
    return null;
  }

  return <FloatingPortal preserveTabOrder={preserveTabOrder} {...rest} />;
};

DropdownPortal.displayName = 'Dropdown.Portal';
